import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MobileTimesheet } from '@/features/timesheet/mobile/MobileTimesheet';
import { DesktopTimesheet } from '@/features/timesheet/desktop/DesktopTimesheet';

export const Route = createFileRoute('/_app/timesheet/')({ component: TimesheetPage });

/** Selettore: Rendicontazione mobile dedicata vs Report mensile desktop (mockup ScreenRend). */
function TimesheetPage() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileTimesheet /> : <DesktopTimesheet />;
}
